
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../controlador';
    import { OpcionMenu } from '@com/a-interfaz/a-controlador';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Modo() { return this.Controlador.Vista.Modo; }
        public get Vista() { return this.Controlador.Vista; }
        public get Items() { return this.Controlador.Vista.Opciones.filter( x => x.Tipo == 'opcion' && !x.Desactivado); }

        public Selected: OpcionMenu = null;
        @Watch( 'Selected' )
        onSelected()
        {
            if ( this.Selected )
            {
                this.Controlador.Vista.Modo = this.Selected.Modo;
                this.Selected = null;
                this.Busqueda = '';
            }
        }
        public Busqueda: string = '';

        async mounted()
        {

            this.Refrescar();
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        public Refresh: boolean = false;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }


        filter( item: OpcionMenu, queryText: string, itemText: string )
        {
            if ( item && queryText )
            {
                const searchText = queryText.toLowerCase();
                return item.Titulo.toLowerCase().includes( searchText );
            }
            return false;
        };
    }
